import rootApi from '@utils/baseAPI/WrapperApi';

export const apiGetAllCustomer = (data) => {
  return rootApi.get('api/customers', { params: data });
};

export const apiGetAllCustomerByeReplacementType = (data) => {
  return rootApi.get('api/customers/by-replacement-type', { params: data });
};

export const apiGetAllCustomerWithDevice = (data) => {
  return rootApi.get('api/customers/device', { params: data });
};

export const apiGetCustomerById = (id) => {
  return rootApi.get(`api/customer/${id}`);
};

export const apiCreateCustomer = (data) => rootApi.post('api/customer', data);
export const apiUpdateCustomer = (data, id) => rootApi.put(`api/customer/${id}`, data);
export const apiDeleteCustomer = (id) => rootApi.delete(`api/customer/${id}`);

export const apiDownloadTemplate = (data) => rootApi.post('api/customer/export-template', data);
export const apiImportExcel = (data) => rootApi.post('api/customer/import', data);

export const apiGetStatisticsData = (data) => {
  return rootApi.get('api/customer/statistics', { params: data });
};

export const apiGetStatisticsCustomerByDay = (data) => {
  return rootApi.get('api/customer/v2/statistics-customer-by-day', { params: data });
};

export const apiGetStatisticsCustomerByDayV2 = (data) => {
  return rootApi.get('api/customer/v2/statistics-customer-by-day-v2', { params: data });
};

export const apiExportStatisticsReport = (data) => {
  return rootApi.get('api/customer/export-statistics-report', { params: data });
};

export const apiGetStatisticsDataByMonth = (data) => {
  return rootApi.get('api/customer/consumptions-by-month', { params: data });
};

export const apiGetStatisticsDataByMonthV2 = (data) => {
  return rootApi.get('api/customer/v2/statistics', { params: data });
};

export const apiGetConsumptionMonitoring = (data) => {
  return rootApi.get('api/customer/v2/consumption-monitoring', { params: data });
};

export const apiGetConsumptionByBranchByDay = (data) => {
  return rootApi.get('api/customer/v2/consumption-by-branch-by-day', { params: data });
};

export const apiGetStatisticsDataByMonthV3 = (data) => {
  return rootApi.get('api/statistics-month', { params: data });
};

export const apiGetStatisticsDataByMonthCnhpComparison = (data) => {
  return rootApi.get('api/statistics-month/cnhp-comparison', { params: data });
};

export const apiGetSummaryStatisticsDataByMonthV3 = (data) => {
  return rootApi.get('api/statistics-month/summary', { params: data });
};

export const apiGetStatisticsDataByMonthByCustomerV2 = (data) => {
  return rootApi.get('api/customer/v2/statistics-by-customer', { params: data });
};

export const apiGetStatisticsDataByMonthDetail = (data) => {
  return rootApi.get('api/customer/consumption-by-month/detail', { params: data });
};

export const apiGetSumConsumptionByMonth = (data) => {
  return rootApi.get('api/customer/v2/sum-consumption', { params: data });
};

export const apiCalculateStatisticsMonth = (data) => {
  return rootApi.get('api/customer/v2/statistics/calculate-month', { params: data });
};

export const apiGetSumConsumptionByDay = (data) => {
  return rootApi.get('api/customer/v2/sum-statistics-customer-by-day', { params: data });
};

export const apiGetProcessManagement = (data) => {
  return rootApi.get('api/process-management', { params: data });
};

export const apiImportManualReadings = (data) => {
  return rootApi.post('api/statistics-month/import-manual-readings', data);
};

export const apiExportTemplateManualReadings = (data) => {
  return rootApi.get('api/statistics-month/export-template-manual-readings', { params: data });
};

export const apiGetNightMinConsumptionTracking = (data) => {
  return rootApi.get('api/customer/v2/night-min-consumption-tracking', { params: data });
};

export const apiExportNightMinConsumptionTracking = (data) => {
  return rootApi.get('api/customer/v2/night-min-consumption-tracking/export', {
    params: data,
    responseType: 'blob'
  });
};

export const apiClearNightMinConsumptionCache = () => {
  return rootApi.delete('api/customer/v2/night-min-consumption-tracking/cache');
};
